import { identify, makeRequest, Service } from 'utils/http';

export async function getDeliveryDocumentApi(deliveryId: string) {
  return makeRequest(Service.getDeliveryDocument(deliveryId, await identify()));
}
